import React from 'react';

const LandingPage = () => {
  const handleRedirect = () => {
    window.location.href = 'https://medviewer.net/';
  };

  return (
    <div
      className="flex items-center justify-center h-screen w-screen bg-black overflow-hidden relative select-none cursor-default"
      style={{
        background: 'radial-gradient(circle at center, #1a0505 0%, #000000 70%)'
      }}
    >
      {/* Dynamic Background Glow */}
      <div className="absolute w-[1000px] h-[1000px] bg-red-900/10 rounded-full blur-[120px] animate-pulse-slow"></div>

      <div className="text-center z-10 flex flex-col items-center">
        <h1
          className="text-8xl md:text-[14rem] font-bold tracking-tighter cursor-pointer transition-all duration-500 hover:scale-[1.03] active:scale-[0.97] group relative"
          onClick={handleRedirect}
          style={{
            color: '#fff',
            textShadow: `
              0 0 7px #fff,
              0 0 10px #fff,
              0 0 21px #fff,
              0 0 42px #e11d48,
              0 0 82px #e11d48,
              0 0 92px #e11d48,
              0 0 102px #e11d48,
              0 0 151px #e11d48
            `
          }}
        >
          MedViewer
        </h1>

        <div className="mt-12 opacity-80">
          <p
            className="text-red-500 text-lg md:text-3xl tracking-[0.6em] font-medium uppercase animate-glow-soft"
            style={{
              textShadow: '0 0 10px rgba(225, 29, 72, 0.8), 0 0 20px rgba(225, 29, 72, 0.4)'
            }}
          >
            by medSoft Technologies
          </p>
        </div>
      </div>

      <style>{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.1; transform: scale(1); }
          50% { opacity: 0.15; transform: scale(1.1); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 8s ease-in-out infinite;
        }
        @keyframes glow-soft {
          0%, 100% { filter: brightness(1); }
          50% { filter: brightness(1.3); }
        }
        .animate-glow-soft {
          animation: glow-soft 4s ease-in-out infinite;
        }

        /* Neon Flickering Effect on Hover */
        h1:hover {
          animation: flicker 1.5s infinite alternate;
        }

        @keyframes flicker {
          0%, 18%, 22%, 25%, 53%, 57%, 100% {
            text-shadow:
              0 0 7px #fff,
              0 0 10px #fff,
              0 0 21px #fff,
              0 0 42px #e11d48,
              0 0 82px #e11d48,
              0 0 92px #e11d48,
              0 0 102px #e11d48,
              0 0 151px #e11d48;
          }
          20%, 24%, 55% {
            text-shadow: none;
            color: #333;
          }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
